module.exports = __webpack_public_path__ + "static/media/gchat_step-1.5e7df29f.svg";